import { Component, OnInit } from "@angular/core";
import { DataService } from "../../shared/dataService";
import { IProduct } from "../../shared/product";
import { Router } from "@angular/router";

@Component({
    selector: 'pm-products',
    templateUrl: './productListAdmin.component.html',
    styleUrls:['./productListAdmin.component.css']
})
export class ProductListAdmin implements OnInit {
    constructor(private data: DataService, private router: Router) {
        this.filteredProducts = this.products;
        this.listFilter = '';
    }
    pageTitle: string = 'Lista de productos';

    public filteredProducts: IProduct[] = [];
    public products: IProduct[] = [];
    imageWidth: number = 50;
    imageMargin: number = 2;
    showImage: boolean = false;
    _listFilter: string;
    get listFilter(): string {
        return this._listFilter;
    }
    set listFilter(value: string) {
        this._listFilter = value;
        this.filteredProducts = this.listFilter ? this.performFilter(this.listFilter) : this.products;
    }

    ngOnInit(): void {
        this.data.loadProducts()
            .subscribe(success => {
                if (success) {
                    this.products = this.data.products;
                    this.filteredProducts = this.data.products;

                } else {
                    // TODO: Handle error
                    // error => this.errorMessage =<any>error
                    // Module "Retrieve data using http
                    // https://app.pluralsight.com/player?course=angular-2-getting-started-update&author=deborah-kurata&name=angular-2-getting-started-update-m9&clip=7&mode=live
                    // "Angular: Reactive forms"
                    // "Play by Play: Angular 2/RxJS/ HTtp and Restful services

                }
            });
    }

    performFilter(filterBy: string): IProduct[] {
        filterBy = filterBy.toLocaleLowerCase();
        return this.products.filter((product: IProduct) =>
            product.title.toLocaleLowerCase().indexOf(filterBy) !== -1);
    }

    toggleImage(): void {
        this.showImage = !this.showImage;
    }

    onRatingClicked(message: string): void {
        this.pageTitle = 'Product List: ' + message;
    }
}